import { NodeInterface } from "@swivl-mono/types";
import { TagInput, TagInputType } from "../../../../Components/TagInput/TagInput";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import DelayComponent from "../SidePanel/Inspector/components/DelayComponent";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";
import CommandCustomInput from "../SidePanel/Inspector/components/CommandCustomInput";
import { RandomId } from "@swivl-mono/helpers";



const Command = {
  Type: "command",
  Empty: function() {
          return {
              "id": RandomId(6),
              "type": Command.Type,
              "delay": 0,
              "showTyping":false,
              "command": "navigateTo",
              "url": "",
              "element": "",
              "replaceWith": "",
              "custom": [{"commandKey":"key1", "result":"value1"}],
              "onCompleteGoto": null
            }
    },

    PlumbData: function(node:NodeInterface) {

      return TabNodeLayoutData({
        node: node,
        label: "Command",
        title: node.command ,
        baseWidth: 130,
        tabs:[{id: "onCompleteGoto", source: "onCompleteGoto", target: node.onCompleteGoto,}]
      });

    },

   InspectorPanel: class CommandInspectorPanel extends NodePanel{
     constructor(props:any) {   
          super(props);
       this.addDropdown = this.addDropdown.bind(this)
       this.updateCommand = this.updateCommand.bind(this)
       this.state = {command:this.props.node.command}
     }

    addDropdown() {
      let customData = {"commandKey": "", "result": ""};
      this.addItemToArray(customData, "custom", true)
    }

    updateCommand(event:any) {
      var valEvent = event;
      var newVal = event.target.value;
      this.setState({command: newVal});
      this.onChange(valEvent);
    }

    render() {
      var self = this;
      let commandContent, replaceWith, image;
      let customCommandSets;
      if (this.props.node.custom) {
        customCommandSets = this.props.node.custom.map(function(item:any, index:any) {
          return <div className="customRow" key={index}><CommandCustomInput

          onChange={self.onChangeUpdateAndRedraw} commandKey={self.props.node.custom[index].commandKey} result={self.props.node.custom[index].result} arrayName="custom" index={index} deleteValue={self.deleteValue} /></div>
        })
      }

      replaceWith = this.props.node.command == "replaceText" ? (<div><div className="commandTitle">REPLACE WITH</div><input className="commandInput" name="replaceWith" value={this.props.node.replaceWith} onChange={this.onChange} /></div>) : null;

      image = this.props.node.command == "replaceImage" ? (<div><div className="commandTitle">IMAGE URL</div><input className="commandInput" name="replaceWith" value={this.props.node.replaceWith} onChange={this.onChange} /></div>) : null;

      if (this.props.node.command == "custom") {
        commandContent = (<div className="commandCustomInput">
          {customCommandSets}
          <div className="addElementButton" onClick={this.addDropdown}>+ ADD PAIR</div>
        </div>);
      } else {
        if (this.props.node.command == "navigateTo") {



          commandContent = (<div className="commandElementInput">
            <div className="commandTitle">URL</div>
            <TagInput
                    type={TagInputType.SingleLine}
                                  value={this.props.node.url}
                                  onChange={this.onChange}
                                  name="url"
                                  placeholder="Enter url..."
                                   />




          </div>);
        } else {
        commandContent = (<div className="commandElementInput">
          <div className="commandTitle">ELEMENT</div>
          <input className="commandInput" name="element" value={this.props.node.element} onChange={this.onChange} />
        </div>);
        }
      }

      return (<div>
        <div className="panel command_panel">
          <InspectorNodeHeader title="Command" />
            <DelayComponent node={this.props.node} onChange={this.onChange} />
            <div className="commandType">
              <span className="label">Type</span>
              <div className="radioButtons">
                <form>
                  <div className="radioItem">
                    <label className="inspectorLabel">
                      <input type="radio" name="command" value="navigateTo" onChange={this.updateCommand} checked={(this.state as any).command === 'navigateTo'} />
                      <span className="radioText">Navigate To</span>
                    </label>
                  </div>
                  <div className="radioItem">
                    <label className="inspectorLabel">
                      <input type="radio" name="command" value="scrollElement" onChange={this.updateCommand} checked={(this.state as any).command === 'scrollElement'} />
                      <span className="radioText">Scroll To</span>
                    </label>
                  </div>
                  <div className="radioItem">
                    <label className="inspectorLabel">
                      <input type="radio" name="command" value="replaceText" onChange={this.updateCommand} checked={(this.state as any).command === 'replaceText'} />
                      <span className="radioText">Replace Text</span>
                    </label>
                  </div>
                  <div className="radioItem">
                    <label className="inspectorLabel">
                      <input type="radio" name="command" value="replaceImage" onChange={this.updateCommand} checked={(this.state as any).command === 'replaceImage'} />
                      <span className="radioText">Replace Image</span>
                    </label>
                  </div>
                  <div className="radioItem">
                    <label className="inspectorLabel">
                      <input type="radio" name="command" value="custom" onChange={this.updateCommand} checked={(this.state as any).command === 'custom'} />
                      <span className="radioText">Custom</span>
                    </label>
                  </div>
                </form>
              </div>
            </div>
          {commandContent}
          {replaceWith}
          {image}
          <div className="carouselPadding">.</div>
        </div>
        <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
      </div>)
     }
   }
}
export default Command;
